import { Component, Input } from '@angular/core';
import { CandidatStatusOnMission, FlagType } from '../utils/enums';
import { Router } from '@angular/router';
import { MissionService } from '../../services/mission.service';
import { AuthService } from '../../services/auth.service';
import { FlagService } from '../services/flag.service';
import { MatDialog } from '@angular/material/dialog';
import { DetailRefuComponent } from '../../pages/candidat/detail-refu/detail-refu.component';
import { FormAnnulationContractComponent } from '../../pages/candidat/form-annulation-contract/form-annulation-contract.component';
import { CandidatMissionStatusPipe } from '../pipes/candidat-mission-status.pipe';
import { ActualWorkingHoursComponent } from '../../pages/candidat/components/actual-working-hours/actual-working-hours.component';

@Component({
  selector: 'app-status-candidat-mission',
  templateUrl: './status-candidat-mission.component.html',
  styleUrl: './status-candidat-mission.component.scss',
})
export class StatusCandidatMissionComponent {
  @Input() data: any;
  @Input() column: any;
  statusOfCandidatOnMission = CandidatStatusOnMission;
  statusText: any;
  constructor(
    private router: Router,
    private missionApi: MissionService,
    private auth: AuthService,
    private flag: FlagService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
  }
  goTo(id: number) {
    this.router.navigate(['missinDetails', id]);
  }

  /**
   * Mission terminée sans contrat signé (candidature jamais retenue, contrat accepté mais non signé) : même libellé que
   * l'espace agence (« Terminée sans affectation ») au lieu d'un statut de candidature encore « en attente ».
   */
  get endedWithoutAssignment(): boolean {
    const status = this.data?.statusOfCandidatOnMission;
    if (status != this.statusOfCandidatOnMission.CANDIDAT_APPLIED_ON_THIS_MISSION
      && status != this.statusOfCandidatOnMission.ACCEPTED
      && status != this.statusOfCandidatOnMission.CONTRACT_PENDING_VALIDATION) {
      return false;
    }
    if (!this.data?.enddate) return false;
    const end = new Date(`${this.data.enddate}T${this.data.endtime || '23:59:59'}`);
    return !isNaN(end.getTime()) && end.getTime() < Date.now();
  }

  /**
   * Saisie des heures réelles : missions payées / en attente de paiement, ET missions terminées dont le contrat est signé
   * (cas normal : sans cela, un pro ne pouvait pas déclarer ses heures avant la validation de l'agence).
   */
  get canEnterHours(): boolean {
    const status = this.data?.statusOfCandidatOnMission;
    if (status == this.statusOfCandidatOnMission.PAYMENT_DONE
      || status == this.statusOfCandidatOnMission.MISSION_VALIDATED_WAITING_FOR_PAYMENT) {
      return true;
    }
    if (status == this.statusOfCandidatOnMission.ACCEPTED_AND_SIGNED_BY_BOTH && this.data?.enddate) {
      const end = new Date(`${this.data.enddate}T${this.data.endtime || '23:59:59'}`);
      return !isNaN(end.getTime()) && end.getTime() <= Date.now();
    }
    return false;
  }

  openImputationDialog(mission:any){
    console.log(mission);
    
    const dialogRef = this.dialog.open(ActualWorkingHoursComponent, {
      width: '800px',
      data: {
        missionId: mission.id,
        startDate: mission.startdate,
        endDate: mission.enddate,
        establishmentName: mission.etablissementNom,
        serviceName: mission.serviceAffectationsName,
        missionReference: mission.missionTitle,
        workingHours: mission.workingHours,
        // E3 (client clinique — P5) : heures théoriques pour le pré-remplissage
        startTime: mission.starttime,
        endTime: mission.endtime,
        pauseTime: mission.pauseTime,
        dailyHours: mission.dailyHours
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Refresh mission data or show success message
        console.log('Working hours were saved successfully');
      }
    });
  }

  deleteMission(id: number) {
    this.missionApi
      .SupprissionMission({
        candidatId: Number(this.auth.user?.collary_id),
        missionId: id,
        status: 'ARCHIVED',
      })
      .subscribe({
        next: (data: any) => {
          this.flag.displayFlag(
            'La mission a été supprimée avec succès !',
            FlagType.success
          );
          this.missionApi.toggleRefreshMission();
        },
        error: (err) => console.log(err),
      });
  }
  voirDetails(data: any) {
    this.dialog.open(DetailRefuComponent, {
      backdropClass: 'bg-transparent',
      width: '400px',
      data,
      // animation: { to: "left" }
    });
  }
  sendMail(data: any) {
    this.dialog.open(FormAnnulationContractComponent, {
      backdropClass: 'bg-transparent',
      data: {
        data,
        textFormulaire: `Contester le refus de validation de ma mission N° ${data.id}`,
      },
    });
  }
}
